export default "__VITE_ASSET__BrIs1ZW3__"